import { Form, Input } from 'antd';
import SearchIcon from 'assets/Icons/search';
import Button from 'components/Button';
import settingServiceActions from 'features/settingService/services/actions';
import styled from 'styled-components';
import { useAppDispatch } from 'store/hooks';
import { useRef } from 'react';
import { IModalAddOrUpdateSupplierRef } from './Modals/AddOrUpdateSupplierModal';
import AddOrUpdateSupplierModal from './Modals/AddOrUpdateSupplierModal';

const SuppliersSettingFilter = () => {
  const [form] = Form.useForm();
  const dispatch = useAppDispatch();
  const modalAddOrUpdateSupplierRef = useRef<IModalAddOrUpdateSupplierRef>(null);

  const handleFinish = (values: any) => {
    dispatch(
      settingServiceActions.setSuppliersSettingParams({
        page: 1,
        keySearch: values.keySearch,
      })
    );
  };

  const onClickNewSupplier = () => {
    modalAddOrUpdateSupplierRef.current?.open(undefined, () => {
      dispatch(settingServiceActions.setSuppliersSettingParams());
    });
  };

  return (
    <Form form={form} onFinish={handleFinish}>
      <Container>
        <Form.Item name='keySearch' noStyle>
          <Input placeholder='Search by name' size='large' suffix={<SearchIcon />} />
        </Form.Item>
        <Button height={4} ntype='PRIMARY' htmlType='submit'>
          Search
        </Button>
        <Button color='white' icon='addWhite' height={4} ntype='GREEN' onClick={onClickNewSupplier}>
          New Supplier
        </Button>
      </Container>
      <AddOrUpdateSupplierModal ref={modalAddOrUpdateSupplierRef} />
    </Form>
  );
};

export default SuppliersSettingFilter;

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;
